import { makeStyles } from '@material-ui/core';

const filterStyles = makeStyles({
  boxFilter: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '8px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  },
  filterTitle: {
    height: '50px',
    padding: '15px 0px',
    fontSize: '18px',
    lineHeight: '20px',
    color: '#777',
  },
  button: {
    backgroundColor: '#f26522',
    textTransform: 'uppercase',
    padding: '8px 16px',
    height: 'auto',
    textAlign: 'center',
    color: '#FFF',
    borderRadius: '8px',
    border: 'none',
    transition: 'all .4s',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#f264226c',
    },
  },
  inputDate: {
    backgroundColor: '#ecf0f1',
    padding: '4px  12px',
    color: '#333',
    border: 'none',
    borderRadius: '8px',
    outline: 'none',
    fontSize: '1rem',
    width: '100%',
  },
  inputSelect: {
    backgroundColor: '#ecf0f1',
    borderRadius: '8px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '400',
    lineHeight: '1.1876em',
    cursor: 'text',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '4px 12px',
    border: 'none',
    outline: 'none',
    display: 'inline-flex',
    flexDirection: 'column',
    verticalAlign: 'top',
    width: '100%',
  },
});

export default filterStyles;
